module.exports = __webpack_public_path__ + "static/img/introduction-1.db595bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduction-1.png
// module id = +ixa
// module chunks = 0